import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ButtonControl } from "../../Buttons/ButtonControl";
import { Modal } from "../../Modals/Modal";

import styles from "./BlockPatientMessagingPopup.module.scss";

interface IBlockPatientMessagingPopupProps {
    onCancelClick: () => void;
    onBlockClick: (reason: string) => void;
}

export function BlockPatientMessagingPopup(props: Readonly<IBlockPatientMessagingPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    const [reason, setReason] = useState<string>("");

    return (
        <Modal
            title={getText("SharedItem_BlockPatientCommunicationsLabel")}
            onClose={() => {}}
            footer={(
                <div className={styles.actionButtonContainer}>
                    <ButtonControl
                        variant="neutral"
                        onClick={() => props.onCancelClick()}
                        label={getText("CancelLabel")}
                    />
                    <ButtonControl
                        variant="error"
                        onClick={() => props.onBlockClick(reason)}
                        label={getText("SharedItem_BlockLabel")}
                    />
                </div>
            )}
            roundTopCorner
            draggable
            fixedOverlayPosition
            top={150}
        >
            <div className={styles.mainContainer}>
                <div>
                    {getText("SharedItem_BlockPatientCommunicationsInformation")}
                </div>
                <div className={styles.reasonContainer}>
                    <div className={styles.reasonLabel}>
                        {getText("ReasonLabel")}
                    </div>
                    <div className={styles.reasonText}>
                        <textarea
                            className="form-control"
                            value={reason}
                            onChange={e => setReason(e.target.value)}
                            maxLength={255}
                            rows={4}
                            autoFocus
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
